// Mui Components
import { Button } from "@mui/material";
// Styles
import { styles } from "./styles";

const DropdownButtonIcon = (props) => {
  return (
    <Button {...props} sx={[styles.button, props.sx]}>
      <img src={props.prevIcon} alt="" />
      {props.children}
    </Button>
  );
};

export default DropdownButtonIcon;
